import { SvgIconProps } from 'ui/icons/SvgIcon';

export const UserInitiatedTemplate = ({ height = 110, width = 60 }: SvgIconProps) => (
  <svg
    width="129"
    height="150"
    viewBox="0 0 129 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ddd_8862_73875)">
      <rect
        x="26"
        y="10"
        width={width}
        height={height}
        rx="4"
        fill="#ECE5DD"
        shapeRendering="crispEdges"
      />
      <g>
        <path
          d="M62.3663 33H99.4023C101.262 32.9989 102.77 34.5202 102.769 36.3963V39.0916L108.636 47.3793C109.506 48.6094 108.729 50.3279 107.239 50.4728C106.93 50.5028 106.619 50.458 106.331 50.3421L102.769 48.9046V49.6037C102.77 51.4798 101.262 53.0011 99.4023 53H62.3663C60.5071 52.9998 59 51.4794 59 49.6037V36.3963C59 34.5206 60.5071 33 62.3663 33Z"
          fill="#D5EDC1"
        />
      </g>
    </g>
    <path
      d="M26 14C26 11.7909 27.7909 10 30 10H82C84.2091 10 86 11.7909 86 14V22H26V14Z"
      fill="#128C7E"
    />
    <g filter="url(#filter2_ddd_8862_73875)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 60C17.7909 60 16 61.7909 16 64V71.0938L8.40373 80.9262C7.33817 82.3055 8.52426 84.2792 10.3003 84.0822L16.0247 83.4473C16.2471 85.4459 17.9421 87 20 87H64C66.2091 87 68 85.2091 68 83V64C68 61.7909 66.2091 60 64 60H20Z"
        fill="white"
      />
      <path
        d="M21 67H43"
        stroke="#E0DEDF"
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 74H57"
        stroke="#E0DEDF"
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 81H57"
        stroke="#E0DEDF"
        strokeWidth="2.7"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_ddd_8862_73875"
        x="6"
        y="0"
        width="123"
        height="150"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8862_73875" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_8862_73875"
          result="effect2_dropShadow_8862_73875"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="10" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_8862_73875"
          result="effect3_dropShadow_8862_73875"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_8862_73875"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_ddd_8862_73875"
        x="51"
        y="29"
        width="66"
        height="36"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8862_73875" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_8862_73875"
          result="effect2_dropShadow_8862_73875"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_8862_73875"
          result="effect3_dropShadow_8862_73875"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_8862_73875"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_ddd_8862_73875"
        x="0"
        y="56"
        width="76"
        height="43"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="0.5" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_8862_73875" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_8862_73875"
          result="effect2_dropShadow_8862_73875"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_8862_73875"
          result="effect3_dropShadow_8862_73875"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_8862_73875"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
